import axios from 'axios'

export default {
  // 获取加密狗列表
  getDongleList (params) {
    return axios.post('/api/rendering/admin/task/machine/device/list', params)
  },
  // 获取加密狗统计
  getDongleTotal (params) {
    return axios.post('/api/rendering/admin/task/machine/device/num', params)
  },
  // 查看加密狗任务占用情况
  getTaskOccupancySituation (params) {
    return axios.post('/api/rendering/admin/task/machine/device/taskOccupancySituation', params)
  },
  // 加密狗状态更新
  updateDongleStatus (params) {
    return axios.post('/api/rendering/admin/task/machine/device/updateState', params)
  },
  // 导入过期时间
  importExpiredTime (params) {
    return axios.post('/api/rendering/admin/task/machine/device/importExpiredTime', params)
  },
  // 导入过期时间
  delByIds (params) {
    return axios.post('/api/rendering/admin/task/machine/device/delByIds', params)
  },
}
